export default __webpack_public_path__ + "static/media/white-cam-1.dbac1f0c.png";